module.exports = __webpack_public_path__ + "static/media/icon-website.119399f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-website.svg
// module id = 509
// module chunks = 0